export default __webpack_public_path__ + "static/media/fire-protection.47e95d5b.jpg";